import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentMetadata, getDatasetLink, getDatasetName, hasData } from '../selectors/metadata';
import { I18n } from 'common/i18n';
import { VisualizationRenderer } from 'common/visualizations';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';
import { getDataTable } from '../selectors/vifAuthoring';

export const TableView = () => {
  const metadata = useSelector((state: AuthoringWorkflowState) =>
    getCurrentMetadata(state.metadataCollection, state.vifAuthoring),
  );
  const vif = useSelector(getDataTable);
  const tableViewRef = useRef<HTMLDivElement | null>(null);
  const tableRendererRef = useRef<any>(null);

  useEffect(() => {
    if (hasData(metadata) && tableViewRef.current) {
      if (tableViewRef.current.querySelector('.socrata-visualization')) {
        tableRendererRef.current?.update(vif);
      } else {
        tableRendererRef.current = new VisualizationRenderer(vif, tableViewRef.current);
      }
    }
  }, [metadata, vif]);

  const renderBasedOn = () => (
    <span className="authoring-based-on">
      <a href={getDatasetLink(metadata)} className="forge-hyperlink" target="_blank" rel="noreferrer">
        {getDatasetName(metadata)}
      </a>
    </span>
  );

  const basedOn = hasData(metadata) ? renderBasedOn() : null;

  return (
    <div className="authoring-table-view-container">
      <div className="authoring-table-view-title forge-typography--heading1">
        {I18n.t('shared.visualizations.table_view.title')}
        {basedOn}
      </div>
      <div className="authoring-table-view" ref={tableViewRef} />
    </div>
  );
};
